import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateCollectionDatasetsState from './collectionDatasets';
import updateCollectionState from './collection';

const handlers = {
  ...updateCollectionDatasetsState,
  ...updateCollectionState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
